import { render } from "./BaseSpinnerPartial.vue?vue&type=template&id=6d3cd73b"
import script from "./BaseSpinnerPartial.vue?vue&type=script&lang=js"
export * from "./BaseSpinnerPartial.vue?vue&type=script&lang=js"

import "./BaseSpinnerPartial.vue?vue&type=style&index=0&id=6d3cd73b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__